import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FETCH_USER_QUIZZES, GET_NEW_QUESTION_FOR_THE_USER } from "../../constant/Apipath";
import EarnBuilderBucksCard from "./EarnBuilderBucksCard";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { Box } from "@mui/material";
import { English } from "../../constant/EnglishFallback";
import {
  setChoosesite,
  setPreviousQuestionId,
  setSelectedsite,
  setSelectlocation
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";

const Questions = (props) => {
  const { loginData, multiLanguageData, previousQuestionId } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const appLocation = useLocation();
  const LanguageData = multiLanguageData?.RewardStore || {};
  const { TEXT_NO_MORE_QUESTIONS = English.RewardStore.TEXT_NO_MORE_QUESTIONS } =
    LanguageData || {};
  const [earnBuilderBucks, setEarnBuilderBucks] = useState(null);
  const [remainingQuestion, setRemainingQuestion] = useState("");
  const [options, setOptions] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);
  const [prevQueId, setPrevQuesId] = useState(0);
  let dispatch = useDispatch();

  const updateEarnBuck = async (previousQuestionId) => {
    if (loadingData) {
      return;
    }
    // if (props.from !== "new-dashboard") {
      setLoadingData(true);
    // }
    try {
      let questionData;
      console.log("previousQuestionId", previousQuestionId);
      if (previousQuestionId !== 0) {
        const questionObject = {
          PageNr: 1,
          NrOfRecPerPage: 10,
          FullSearch: "",
          UserId: userId,
          IncludeRecordNr: "false",
          SearchList: [{ id: previousQuestionId }]
        };

        const singleQuestionData = await Postrequestcall(
          FETCH_USER_QUIZZES,
          questionObject,
          loginData?.accessToken
        );
        console.log("singleQuestionData==?", singleQuestionData);
        questionData = singleQuestionData?.data?.data?.[0];
      } else {
        const userUrl = `${GET_NEW_QUESTION_FOR_THE_USER}${userId}`;
        const { data } = await Getrequestcall(userUrl, loginData?.accessToken);
        questionData = data?.data;

        // questionData = {
        //   id: 44484,
        //   quizType: "Search",
        //   quizDescription: "What site did you work on that had the worst weather?\r\n",
        //   quiz_EntityName1: "",
        //   quiz_AttributeName1: "",
        //   parameter1: "",
        //   parameter1_Name: "",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Site",
        //   response_AttributeName: "Name",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 2,
        //   answerType: null
        // };

        // questionData = {
        //   id: 197891,
        //   quizType: "Date",
        //   quizDescription: "When did you work on this project?",
        //   quiz_EntityName1: "Project",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "5695",
        //   parameter1_Name: "Gggg p",
        //   parameter1Additional_Name: "108 Ganeshkhind Road ",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Project",
        //   response_AttributeName: "Interval",
        //   canAddResponse: false,
        //   minResponses: 2,
        //   maxResponses: 2,
        //   options: "",
        //   bucks: 2,
        //   answerType: null
        // };
        // questionData = {
        //   id: 17730,
        //   quizType: "Date",
        //   quizDescription: "When did you start your career in construction? \n",
        //   quiz_EntityName1: "",
        //   quiz_AttributeName1: "",
        //   parameter1: "",
        //   parameter1_Name: "",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "",
        //   response_AttributeName: "",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 5,
        //   answerType: null
        // };
        // questionData = {
        //   id: 16027,
        //   quizType: "Select",
        //   quizDescription: "What were you most impressed by on this site? ",
        //   quiz_EntityName1: "Site  ",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "9817",
        //   parameter1_Name: "14May1124",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "",
        //   response_AttributeName: "",
        //   canAddResponse: true,
        //   minResponses: 1,
        //   maxResponses: 3,
        //   options: "Architecture;\nDesign;\nPeople;\nSafety;\n",
        //   bucks: 5,
        //   answerType: null,
        // };
        // questionData = {
        //   id: 15951,
        //   quizType: "Search",
        //   quizDescription: "What products did you use on this project?\n",
        //   quiz_EntityName1: "Project",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "2348",
        //   parameter1_Name: "project23",
        //   parameter1Additional_Name: "Newsite22march24",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Product",
        //   response_AttributeName: "Name",
        //   canAddResponse: true,
        //   minResponses: 1,
        //   maxResponses: 1000,
        //   options: "",
        //   bucks: 5,
        //   answerType: null
        // };
        // questionData = {
        //   id: 16099,
        //   quizType: "Search",
        //   quizDescription: "What role did this company play on this project?\n",
        //   quiz_EntityName1: "Company",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "706",
        //   parameter1_Name: "The Kirkland Partnership Inc",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "Project",
        //   quiz_AttributeName2: "Name",
        //   parameter2: "2779",
        //   parameter2_Name: "27MayProject1",
        //   parameter2Additional_Name: "14May1124",
        //   response_EntityName: "Company's Role",
        //   response_AttributeName: "Name",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 5,
        //   answerType: null,
        // };
        // questionData = {
        //   id: 17481,
        //   quizType: "Search",
        //   quizDescription: "What products did you use on this project?\n",
        //   quiz_EntityName1: "Project",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "3024",
        //   parameter1_Name: "Qwerty1",
        //   parameter1Additional_Name: "123321",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Product",
        //   response_AttributeName: "Name",
        //   canAddResponse: true,
        //   minResponses: 1,
        //   maxResponses: 1000,
        //   options: "",
        //   bucks: 5,
        //   answerType: null,
        // };
        // questionData = {
        //   id: 35722,
        //   quizType: "Address",
        //   quizDescription: "What is the address for this site? \n",
        //   quiz_EntityName1: "Site  ",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "9539",
        //   parameter1_Name: "27march1",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Site  ",
        //   response_AttributeName: "Address",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 2,
        //   answerType: null
        // };
        // questionData = {
        //   id: 83137,
        //   quizType: "Search",
        //   quizDescription:
        //     "What project were you on when you used this product?\n",
        //   quiz_EntityName1: "Product",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "1048",
        //   parameter1_Name: "114",
        //   parameter1Additional_Name: "114",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Project",
        //   response_AttributeName: "Name",
        //   canAddResponse: true,
        //   minResponses: 1,
        //   maxResponses: 1000,
        //   options: "",
        //   bucks: 2,
        //   answerType: null,
        // };
        // questionData = {
        //   "id": 13491,
        //   "quizType": "Search",
        //   "quizDescription": "What was the first site you worked on?\n",
        //   "quiz_EntityName1": "",
        //   "quiz_AttributeName1": "",
        //   "parameter1": "",
        //   "parameter1_Name": "",
        //   "parameter1Additional_Name": "",
        //   "quiz_EntityName2": "",
        //   "quiz_AttributeName2": "",
        //   "parameter2": "",
        //   "parameter2_Name": "",
        //   "parameter2Additional_Name": "",
        //   "response_EntityName": "Site  ",
        //   "response_AttributeName": "Name",
        //   "canAddResponse": false,
        //   "minResponses": 1,
        //   "maxResponses": 1,
        //   "options": "",
        //   "bucks": 5,
        //   "answerType": null
        // }
        // questionData = {
        //   id: 31334,
        //   quizType: "Search",
        //   quizDescription: "What site did you work on that had the best weather?\n",
        //   quiz_EntityName1: "Site  ",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "",
        //   parameter1_Name: "",
        //   parameter1Additional_Name: "",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Site  ",
        //   response_AttributeName: "Name",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 2,
        //   answerType: null
        // };
        // questionData =  {
        //   "id": 94317,
        //   "quizType": "Number",
        //   "quizDescription": "Approximately how many construction companies have you worked for?\n",
        //   "quiz_EntityName1": "",
        //   "quiz_AttributeName1": "",
        //   "parameter1": "",
        //   "parameter1_Name": "",
        //   "parameter1Additional_Name": "",
        //   "quiz_EntityName2": "",
        //   "quiz_AttributeName2": "",
        //   "parameter2": "",
        //   "parameter2_Name": "",
        //   "parameter2Additional_Name": "",
        //   "response_EntityName": "",
        //   "response_AttributeName": "",
        //   "canAddResponse": false,
        //   "minResponses": 1,
        //   "maxResponses": 1,
        //   "options": "",
        //   "bucks": 2,
        //   "answerType": null
        // }
        // questionData = {
        //   id: 67701,
        //   quizType: "Search",
        //   quizDescription: "What company did you work for on this project?\n",
        //   quiz_EntityName1: "Project",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "3256",
        //   parameter1_Name: "2432423434",
        //   parameter1Additional_Name: "2432423434",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Company",
        //   response_AttributeName: "Name",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 5,
        //   answerType: null
        // };
        // questionData = {
        //   id: 86596,
        //   quizType: "Search",
        //   quizDescription: "What trade were you in when working on this project?\n",
        //   quiz_EntityName1: "Project",
        //   quiz_AttributeName1: "Name",
        //   parameter1: "4135",
        //   parameter1_Name: "test 10007",
        //   parameter1Additional_Name: "test 10007",
        //   quiz_EntityName2: "",
        //   quiz_AttributeName2: "",
        //   parameter2: "",
        //   parameter2_Name: "",
        //   parameter2Additional_Name: "",
        //   response_EntityName: "Trade",
        //   response_AttributeName: "Name",
        //   canAddResponse: false,
        //   minResponses: 1,
        //   maxResponses: 1,
        //   options: "",
        //   bucks: 5,
        //   answerType: null
        // };
      }

      if (questionData) {
        if (questionData.quizType === "Select") {
          const options = questionData?.options?.split(";").filter((op) => op?.trim() !== "");
          const newOptions = options.map((op) => {
            return { isSelected: false, optionName: op, isTextField: false };
          });
          setOptions(newOptions);
        }
        setEarnBuilderBucks(questionData);
        setPrevQuesId(questionData?.id);
      } else {
        setEarnBuilderBucks(TEXT_NO_MORE_QUESTIONS);
        setRemainingQuestion("empty");
      }
      dispatch(setPreviousQuestionId(0));
    } catch (error) {
      console.error("updateEarnBuck-> Get User Question: ", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    updateEarnBuck(previousQuestionId);
  }, [appLocation]);

  useEffect(() => {
    return () => {
      dispatch(setChoosesite(null));
      dispatch(setSelectedsite(null));
      let closeMapModal = {
        lat: 0,
        lng: 0,
        open: false,
        from: ""
      };
      dispatch(setSelectlocation(closeMapModal));
    };
  }, []);

  return (
    <Box className="main-content-card-list">
      {loadingData ? (
        <Loader />
      ) : (
        <EarnBuilderBucksCard
          id={earnBuilderBucks?.id}
          getQuestions={() => {
            updateEarnBuck(0);
          }}
          question={earnBuilderBucks}
          remainingQuestion={remainingQuestion}
          config="view-edit"
          TEXT_NO_MORE_QUESTIONS={TEXT_NO_MORE_QUESTIONS}
          prevQueId={prevQueId}
          setLoadingData={setLoadingData}
          from={props?.from}
          appLocation={appLocation}
          options={options}
          selectedSite={selectedSite}
          setSelectedSite={setSelectedSite}
          fromDashboard={props?.from}
          setVisibleQuestions={props?.setVisibleQuestions}
          setAnswercount={props?.setAnswercount}
        />
      )}
    </Box>
  );
};

export default Questions;
